import * as React from "react";
import {Box, Button, Typography} from "@mui/material";

function DocumentsPanelHeader({description, allRowsAreExpanded, onToggleAll}) {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} pl={2} pr={1} py={1} mb={0.5}>
            <Typography variant="body2" color="text.secondary">{description}</Typography>
            <Button size="small" onClick={onToggleAll} sx={{flexShrink: 0, whiteSpace: 'nowrap'}}>
                {allRowsAreExpanded ? 'Colapsar todo' : 'Expandir todo'}
            </Button>
        </Box>
    );
}

export default DocumentsPanelHeader;
